import { Component, OnInit } from '@angular/core';
import { NeproseService } from 'src/app/services/neprose.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-expired-properties',
  templateUrl: './expired-properties.component.html',
  styleUrls: ['./expired-properties.component.css']
})
export class ExpiredPropertiesComponent implements OnInit {

  dataLoaded: boolean

  propertyList = []

  municipalityList = []

  adPlans = []

  constructor( private _neproseService: NeproseService, private route: ActivatedRoute, private _router: Router, private _notification: MatSnackBar ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { municipalityList: any, adPlans: any})=> {
      this.municipalityList = data.municipalityList.municipalities
      this.adPlans = data.adPlans
    })
    this.getPropertyList()
  }

  getPropertyList(){
    this._neproseService.getMyProperties().subscribe(data => {
      this.dataLoaded = true
      if(data.propertyAd){
        let propertyList = data.propertyAd
        for(let property of propertyList){
          if(property.status == 'expired'){
            let plan = this.adPlans.find(adPlan => adPlan.id == property.ad_plan_id)
            if(plan){
              property['expiryDate'] = this.addDays(property['approvalDate'], plan.validityDays).slice(0, 10)
            }
            this.addPropertyToArray(property)
          }
        }
      }
    })
  }

  addPropertyToArray(property){
    property['featuredImage'] = null
    if(property.PropertyImage){
      let propertyImages = JSON.parse(property.PropertyImage.imagePath)
      if(propertyImages.length > 0){
        property.featuredImage = environment.api+'/images/'+propertyImages[0]
      }
    }
    let municipality = this.municipalityList.find(municipality => municipality.id == property.municipality_id)
    let address = municipality.municipality
    if(property.village){
      address = property.village+', '+address
    }
    property['address'] = address
    this.propertyList.push(property)
  }

  paymentForProperty(id){
    this._router.navigate(['/property/'+id+'/payment'])
  }


  viewProperty(id){
    this._router.navigate(['/editproperty/'+id])
  }

  editProperty(id){
    this._router.navigate(['/edit-property/'+id])
  }

  addDays(approvalDate, days){
    var date = new Date(approvalDate)
    date.setDate(date.getDate() + days)
    return date.toISOString()
  }

}


